import {getNextOptionFromArrowing} from './keyboard-navigation'
import {filterNonSelectableOptions} from '../filterNonSelectableOptionItems'

export function getNextSelectedOptionModelFromArrowPress(direction="", menuState={}) {


    //Use a menu layout that does not include DISABLEDS or INVISIBLES
    const menuLayout = filterNonSelectableOptions(
        menuState.activeViewModel.menuOptionsLayout,
        menuState.activeViewModel.menuOptions
    );

    //Get the active "key" in menuOptions Object by looking up the selectedOptionId
    const activeKey = Object.keys(menuState.activeViewModel.menuOptions).find(key => {
        const model = menuState.activeViewModel.menuOptions[key];
        return model.id === menuState.selectedOptionId
    });

    //Get the next active "key" from our utility
    const nextOptionKey = getNextOptionFromArrowing(direction, menuLayout, activeKey);

    //Look up by Key and return the option model
    return menuState.activeViewModel.menuOptions[nextOptionKey];
    
}


// WEBPACK FOOTER //
// ./src/menu-engine/keyboard/handleArrowPress.js